import Vue from 'vue';
import router from 'vue-router';
import Home from './pages/home_page.vue';
import LayoutHome from './pages/layout_home';
const Search = () => import('./pages/search_page.vue');
const Login = () => import('./pages/login_page.vue');
const Registe = () => import('./pages/registe_page.vue');
const Forget = () => import('./pages/forget_page.vue');
const Graduate = () => import('./pages/graduate_page.vue');
const Analyze = () => import('./pages/analyze_page.vue');
const SalarySystem = () => import('./pages/salary_system_page.vue');
const MemberCenter = () => import('./pages/member_center_page.vue');
const NotFound = () => import('./pages/404_page.vue');
const About = () => import('./pages/about_page.vue');
const WiseChoices = () => import('./pages/wisechoices_page.vue');
const Check = () => import('./pages/check_page.vue');
const manyidu = () => import('./pages/manyidu_page.vue');
const peixun = () => import('./pages/peixun_page.vue');
const MBTI = () => import('./pages/mbti_page.vue');
const Personality = () => import('./pages/personality_page.vue');
const Recommend = () => import('./pages/recommend_page.vue');
const Toolbox = () => import('./pages/toolbox_page.vue');
const Cooperater = () => import('./pages/cooperater_page.vue');
const kechengxiangqing = () => import('./pages/kechengxiangqing.vue');
const Zixunfuwu = () => import('./pages/zixunfuwu.vue');
Vue.use(router);
const routes = new router({
  // mode:'history',
  routes:[
    {
      path:'/',
      name:'',
      component:LayoutHome,
      children:[
        {
          path:'',
          name:'home',
          component:Home,
          meta:{index:1},
        },
        {
          path:'search',
          name:'search',
          component:Search,
          meta:{index:2},
        },
        {
          path:'zixunfuwu',
          name:'zixunfuwu',
          component:Zixunfuwu,
          meta:{index:2},
        },
        {
          path:'graduate',
          name:'graduate',
          component:Graduate,
          meta:{index:3},
        },      
        {
          path:'analyze',
          name:'analyze',
          component:Analyze
        },
        {
          path:'member-center',
          name:'member-center',
          component: MemberCenter,
          meta:{
            requiresAuth:true
          }
        },
        {
          path:'salary-system',
          name:'salary-system',
          component:SalarySystem
        },
        {
          path:'check',
          name:'check',
          component:Check,
          meta:{index:4},
        },
        {
          path:'mbti',
          name:'mbti',
          component:MBTI,
          meta:{index:4},
        },
        {
          path:'personality',
          name:'personality',
          component:Personality,
          meta:{index:4},
        },
        {
          path:'manyidu',
          name:'manyidu',
          component:manyidu,
          meta:{index:4},
        },
        {
          path:'peixun',
          name:'peixun',
          component:peixun,
          meta:{index:4},
        },
        {
          path:'kechengxiangqing',
          name:'kechengxiangqing',
          component:kechengxiangqing,
          meta:{index:4},
        },
        {
          path:'recommend',
          name:'recommend',
          component:Recommend,
          meta:{index:5},
        },        
        {
          path:'toolbox',
          name:'toolbox',
          component:Toolbox,
          meta:{index:6},
        },
        {
          path:'about',
          name:'about',
          component:About,
          meta:{index:5},
        },        
        {
          path:'wisechoices',
          name:'wisechoices',
          component:WiseChoices
        }
      ]
    },
    {
      path:'/registe',
      name:'registe',
      component:Registe
    },    
    {
      path:'/login',
      name:'login',
      component:Login
    },
    {
      path:'/cooperater',
      name:'cooperater',
      component:Cooperater
    },
    {
      path:'/forget',
      name:'forget',
      component:Forget
    },    
    {
      path:'*',
      component:NotFound
    },
  ]
});
routes.beforeEach((to,from,next)=>{
  let token = sessionStorage.getItem('token') 
  if (to.matched.some(record => record.meta.requiresAuth) && (!token || token === null)) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
});
export default routes;